<template>
  <div class="modal fade" id="preScheduleFormModal" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" :key="uniqueKey">

        <div class="modal-header bg-light">
          <div class="d-flex align-items-center">
            <div class="symbol symbol-40px me-3">
              <div class="symbol-label bg-primary">
                <i class="bi bi-clipboard-check fs-2 text-white"></i>
              </div>
            </div>
            <div>
              <h5 class="modal-title mb-0">
                {{ isEditMode ? 'Editar Formulário' : 'Novo Formulário' }}
              </h5>
              <span class="text-muted fs-7">Configure o formulário de pré-agendamento</span>
            </div>
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submit">
            <div class="row g-4">
              <!-- Informações Básicas -->
              <div class="col-12">
                <div class="card border-0 bg-light bg-opacity-50">
                  <div class="card-body p-4">
                    <div class="row g-4">
                      <div class="col-md-8">
                        <label class="form-label fw-semibold required">
                          Nome do Formulário
                        </label>
                        <input type="text" class="form-control form-control-solid"
                               required placeholder="Ex. Formulário de pré-consulta" v-model="formData.form_name"/>
                      </div>

                      <div class="col-md-4">
                        <label class="form-label fw-semibold required">
                          Tipo de Consulta
                        </label>
                        <select v-model="formData.schedule_type" class="form-select form-select-solid" required>
                          <option value="all">Todas</option>
                          <option value="NV">Nova Consulta</option>
                          <option value="RT">Retorno</option>
                        </select>
                      </div>

                      <div class="col-12">
                        <label class="form-label fw-semibold">
                          Descrição
                        </label>
                        <textarea class="form-control form-control-solid" rows="2"
                                  placeholder="Descrição opcional do formulário" v-model="formData.form_description"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Filtros de Aplicação -->
              <div class="col-12">
                <div class="card border-0">
                  <div class="card-header bg-primary bg-opacity-10 border-bottom-0">
                    <h6 class="card-title text-white mb-0 fw-bold">
                      <i class="bi bi-funnel text-white me-2"></i>
                      Aplicação do Formulário
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="row g-4">
                      <div class="col-md-4">
                        <label class="form-label fw-semibold">
                          Grupo de Especialidade
                        </label>
                        <DropdownUbbi :options="specialtyGroups"
                                      :filter="true"
                                      appendTo="self" showClear
                                      v-model="formData.id_spec_group"
                                      optionLabel="spec_group_name"
                                      optionValue="id_spec_group"
                                      empty-message="Nenhuma opção"
                                      empty-filter-message="Nenhuma opção encontrada"
                                      id="id_spec_group"
                                      class="form-control form-control-solid"
                                      placeholder="Todos os grupos"
                        />
                      </div>

                      <div class="col-md-4">
                        <label class="form-label fw-semibold">
                          Profissional
                        </label>
                        <DropdownUbbi :options="professionals"
                                      :filter="true"
                                      appendTo="self" showClear
                                      v-model="formData.id_prof"
                                      optionLabel="prof_name"
                                      optionValue="id_prof"
                                      empty-message="Nenhuma opção"
                                      empty-filter-message="Nenhuma opção encontrada"
                                      id="id_prof"
                                      class="form-control form-control-solid"
                                      placeholder="Todos os profissionais"
                        />
                      </div>

                      <div class="col-md-4">
                        <label class="form-label fw-semibold">
                          Forma de Pagamento
                        </label>
                        <DropdownUbbi :options="paymentMethods"
                                      :filter="true"
                                      appendTo="self" showClear
                                      v-model="formData.id_paymeth"
                                      optionLabel="paymeth_name"
                                      optionValue="id_paymeth"
                                      empty-message="Nenhuma opção"
                                      empty-filter-message="Nenhuma opção encontrada"
                                      id="id_paymeth"
                                      class="form-control form-control-solid"
                                      placeholder="Todas as formas"
                        />
                      </div>
                    </div>

                    <div class="separator separator-dashed my-4"></div>

                    <div class="row g-4 align-items-end">
                      <div class="col-md-3">
                        <label class="form-label fw-semibold required">
                          Enviar Antes
                        </label>
                        <div class="input-group">
                          <input type="number" class="form-control form-control-solid"
                                 required min="1" placeholder="24" v-model="formData.send_before_hours"/>
                          <span class="input-group-text">horas</span>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label class="form-label fw-semibold required">
                          Método de Envio
                        </label>
                        <select v-model="formData.send_via" class="form-select form-select-solid" required>
                          <option value="email">Email</option>
                          <option value="whatsapp">WhatsApp</option>
                          <option value="both">Email e WhatsApp</option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="form-label fw-semibold">
                          Status
                        </label>
                        <div class="form-check form-switch d-flex align-items-center mt-3">
                          <input class="form-check-input" type="checkbox" role="switch" id="active-switch"
                                 v-model="formData.active">
                          <label class="form-check-label ms-2 fw-normal" for="active-switch">
                            {{ formData.active ? 'Ativo' : 'Inativo' }}
                          </label>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <button type="submit" class="btn btn-primary w-100" :disabled="submitting">
                          <i class="bi bi-check-circle me-1"></i>
                          {{ submitting ? 'Salvando...' : (isEditMode ? 'Atualizar' : 'Criar Formulário') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="closeModal">
            <i class="bi bi-x-circle me-1"></i>
            Cancelar
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";
import DropdownUbbi from "@/components/DropdownUbbi.vue";

export default {
  name: "PreScheduleFormModal",
  components: {DropdownUbbi},
  props: ['form'],
  data() {
    return {
      formLocal: null,
      specialtyGroups: [],
      professionals: [],
      paymentMethods: [],
      formData: {
        form_name: null,
        form_description: null,
        schedule_type: 'all',
        id_spec_group: null,
        id_prof: null,
        id_paymeth: null,
        send_before_hours: 24,
        send_via: 'both',
        active: true,
        questions: [],
      },
      formId: null,
      uniqueKey: this.date().unix().toString(),
      submitting: false,
    };
  },
  watch: {
    form: {
      immediate: true,
      handler(newValue) {
        this.formLocal = newValue;
        this.populateModal();
        this.uniqueKey = this.date().unix().toString();
      }
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    isEditMode() {
      return this.form !== null && this.form !== undefined;
    }
  },
  mounted() {
    this.uniqueKey = this.date().unix().toString();
    this.loadSpecialtyGroups();
    this.loadProfessionals();
    this.loadPaymentMethods();
  },
  methods: {
    date: moment,
    loadSpecialtyGroups() {
      http.get(`/specialty-groups`, {params: {kind_exam: false}}).then((response) => {
        this.specialtyGroups = response.data || [];
      }).catch((e) => {
        console.error('Erro ao carregar grupos de especialidade:', e);
      });
    },
    loadProfessionals() {
      http.get(`/places/${this.place.id_place}/professionals`).then((response) => {
        this.professionals = response.data || [];
      }).catch((e) => {
        console.error('Erro ao carregar profissionais:', e);
      });
    },
    loadPaymentMethods() {
      http.get(`/places/${this.place.id_place}/payment-methods`).then((response) => {
        this.paymentMethods = response.data || [];
      }).catch((e) => {
        console.error('Erro ao carregar formas de pagamento:', e);
      });
    },
    populateModal() {
      this.formId = this.formLocal?.id_pre_schedule_form;
      if (!this.formId) {
        this.resetModal();
        return;
      }

      this.formData = {
        form_name: this.formLocal.form_name,
        form_description: this.formLocal.form_description || null,
        schedule_type: this.formLocal.schedule_type,
        id_spec_group: this.formLocal.id_spec_group,
        id_prof: this.formLocal.id_prof,
        id_paymeth: this.formLocal.id_paymeth,
        send_before_hours: this.formLocal.send_before_hours,
        send_via: this.formLocal.send_via,
        active: this.formLocal.active,
        questions: this.formLocal.questions || [],
      };
    },
    async submit() {
      this.submitting = true;
      try {
        if (this.isEditMode) {
          await this.updateForm();
        } else {
          await this.createForm();
        }

        Alert.success('Formulário salvo com sucesso.');
        this.$emit('formSaved');
        this.closeModal();
      } catch (e) {
        Alert.error(e.response?.data?.message || 'Erro ao salvar formulário');
      } finally {
        this.submitting = false;
      }
    },
    async createForm() {
      const payload = {
        ...this.formData,
        id_place: this.place.id_place,
      };
      await http.post(`/places/${this.place.id_place}/pre-schedule-forms`, payload);
    },
    async updateForm() {
      await http.put(`/places/${this.place.id_place}/pre-schedule-forms/${this.formId}`, this.formData);
    },
    closeModal() {
      Modal.toggle('#preScheduleFormModal');
      this.$emit('onClose');
    },
    resetModal() {
      this.formData = {
        form_name: null,
        form_description: null,
        schedule_type: 'all',
        id_spec_group: null,
        id_prof: null,
        id_paymeth: null,
        send_before_hours: 24,
        send_via: 'both',
        active: true,
        questions: [],
      };

      this.formId = null;
    },
  }
}
</script>

<style scoped>
.separator {
  height: 1px;
  background-color: var(--bs-border-color);
  margin: 1rem 0;
}

.separator-dashed {
  background-image: linear-gradient(to right, var(--bs-border-color) 50%, transparent 50%);
  background-size: 8px 1px;
}

.input-group-text {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-border-color);
}

.card {
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  border-radius: 0.75rem;
}

.card-header {
  border-radius: 0.75rem 0.75rem 0 0 !important;
}

.form-check-input:checked {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary);
}

.fs-7 {
  font-size: 0.875rem;
}

/* Responsividade */
@media (max-width: 768px) {
  .modal-xl {
    margin: 0.5rem;
    max-width: calc(100vw - 1rem);
  }

  .row.g-4 > .col-md-4,
  .row.g-4 > .col-md-3 {
    margin-bottom: 1rem;
  }

  .btn.w-100 {
    margin-top: 1rem;
  }
}

@media (max-width: 576px) {
  .col-md-8,
  .col-md-4,
  .col-md-3 {
    margin-bottom: 1rem;
  }

  .d-flex.align-items-end {
    flex-direction: column;
    align-items: stretch !important;
  }

  .btn.w-100 {
    width: 100% !important;
    margin-top: 0.5rem;
  }
}
</style>
